import { compose, withState, withHandlers, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import config from '../../../../config';
import { canUserModifyBarbers } from '../../../common/helpers/users';
import EditTimeTracking from '../components/EditTimeTracking';
import { fetchBarberTimeTrackingBarbers } from '../actions';
import withTimezone from '../../../auth/utils/withTimezone';
import withExtendedTimeTracking from '../hoc/withExtendedTimeTracking';
import { getBarberClockedTime, getFormattedBarberEntries } from '../selectors';

const EditTimeTrackingContainer = compose(
  withRouter,
  withTimezone,
  withExtendedTimeTracking,
  withState('currentDate', 'setCurrentDate', moment().format(config.dateFormatISO)),
  connect(
    (state, ownProps) => ({
      barberId: ownProps.params.barberId,
      totalTime: getBarberClockedTime(state, ownProps.params.barberId),
      entries: getFormattedBarberEntries(state, ownProps.params.barberId),
      canEditTimeTracking: canUserModifyBarbers(state.auth.permissions),
    }),
    { fetchBarberTimeTrackingBarbers }
  ),
  withHandlers({
    fetch: props => () => {
      const day = moment.tz(props.currentDate, config.dateFormatISO, props.timezone);
      const filters = {
        startedAt__gte: day.startOf('day').toJSON(),
        startedAt__lte: day.endOf('day').toJSON(),
      };
      props.fetchBarberTimeTrackingBarbers(props.barberId, filters);
    },
  }),
  withPropsOnChange(
    ['currentDate'],
    (props) => {
      props.fetch();
    }
  ),
)(EditTimeTracking);

export default EditTimeTrackingContainer;
